import Search from './Search'

export type { InputSearchProps } from './Search'

export default Search
